jQuery_T4NT(document).ready(function($){
  setTimeout(function(){
    console.log("Envia");
    $("#custom_cities_ship").change(function(){
      var code = $("#custom_cities_ship").val();
      console.log(code);
      updateItemProperties(code);
    });

    function updateItemProperties(code){
      jQuery.post('/cart/change.js', {
        'line': 1,
        'properties': { '_ciudad_destino_code': code }
      });
    };


    var code = $("#custom_cities_ship").val();

    updateItemProperties(code)
  },900);
});
